import { inject, Service } from '@angular/core';
import { EventBusService } from '@shared';
import { HeaderConfigurationToHeader, ORDERS_HEADER_EVENTS } from './orders-header-events.model';

/**
 * Orders → Header configuration producer.
 */
@Service({ autoProvided: false })
export class OrdersHeaderEventProducerService {
	private readonly eventBus = inject(EventBusService);

	publishHeaderConfiguration(config?: HeaderConfigurationToHeader): void {
		this.eventBus.dispatch(ORDERS_HEADER_EVENTS.HEADER_CONFIGURATION, config);
	}

	configureOrdersHeader(data: Partial<HeaderConfigurationToHeader> = {}): void {
		this.publishHeaderConfiguration({
			showLogo: true,
			headerLeftSectionItems: [
				{ iconName: 'refresh', eventId: 'refresh', ariaLabel: 'بروزرسانی' },
				{ iconName: 'filter', eventId: 'filter', ariaLabel: 'فیلتر' }
			],
			...data
		});
	}

	resetHeader(): void {
		this.publishHeaderConfiguration();
	}

	clearEventSnapshot(eventId: string): void {
		this.eventBus.clearSnapshot(ORDERS_HEADER_EVENTS.HEADER_ACTION, eventId);
	}
}
